<template>
  <v-container grid-list-xl class="pa-5">
    <v-layout wrap>
      <v-flex xs12>
        <m-card-list
          title="Jadwal Kerja"
          label-cari="Cari Jadwal Kerja"
          :items="items"
          :headers="headers"
          :page="page"
          :select="is_admin ? true : false"
          filterUser
          refresh
          @refresh="load()"
          @filter="filter"
          footer
          @change:page="
            pg => {
              cp = pg;
              load();
            }
          "
        >
          <template v-slot:items="{ props, item }">
            <tr v-if="$vuetify.breakpoint.smAndUp">
              <td class="text-left">{{ pVal(item, "nama") }}</td>
              <td class="text-left">
                <v-chip color="primary" label outlined>
                  {{ pVal(item, "nama_jadwal") }}
                </v-chip>
              </td>
              <td>{{ pVal(item, "tgl_berlaku") | toSDN }}</td>
              <td>{{ pVal(item, "tgl_berakhir") | toSDN }}</td>
            </tr>
            <tr v-else>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">
                  {{ headers[0].text }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ pVal(item, "nama") }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">
                  {{ headers[1].text }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ pVal(item, "nama_jadwal") | toStr }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">
                  {{ headers[2].text }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ pVal(item, "tgl_berlaku") | toSDN }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">
                  {{ headers[3].text }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ pVal(item, "tgl_berakhir") | toSDN }}
                </div>
              </td>
            </tr>
          </template>
        </m-card-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import BlockCard from "@/components/BlockCard";

export default {
  components: {
    BlockCard
  },
  data() {
    return {
      items: [],
      jamKerja: {
        filter: false
      },
      user: null,
      users: [],
      showUser: false,
      show: false,
      page: null,
      cp: 1,
      is_aktif: 1,
      headers: [
        { text: "Nama", align: "left", value: "nama" },
        { text: "Jadwal", align: "left", value: "nama_jadwal" },
        { text: "Awal Berlaku", align: "left", value: "tgl_berlaku" },
        { text: "Akhir Berlaku", align: "left", value: "tgl_berakhir" }
      ]
    };
  },
  computed: {
    is_admin() {
      return this.current_user && this.current_user.is_admin == 1
        ? true
        : false;
    }
  },
  activated() {
    this.load();
  },
  methods: {
    load() {
      this.$store
        .dispatch("jadwalKerja/get", {
          kode_organisasi: this.organisasi_id,
          params: {
            page: this.cp,
            from: this.jamKerja.from,
            to: this.jamKerja.to,
            user_id: this.user || 0
          }
        })
        .then(res => {
          this.page = res.data;
          this.items = res.data.data;
          this.show = true;
        })
        .catch(e => e);
    },
    filter(data) {
      this.cp = 1;
      this.user = data.user;
      if (data.dateRange) {
        this.jamKerja.from = data.from;
        this.jamKerja.to = data.to;
        this.load();
      } else {
        this.jamKerja.from = null;
        this.jamKerja.to = null;
        this.load();
      }
    },
    hapus(item) {
      this.$confirmDanger(
        `<div class="ma-1 mb-4 pa-1 row red lighten-4 red--text text--darken-4">

            <i class="ma-3 v-icon v-alert__icon mdi mdi-information-outline red--text text--darken-4"></i>

          <div class="col m11 pa-1 pt-3">
            Pastikan Anda benar-benar mengerti apa yang Anda lakukan.
          </div>
        </div>

        Apakah Anda yakin akan menghapus data ini ?<br>
        <div class="mt-2 title grow text-center">
           ${item.keterangan}<br>
        </div>

      `
      )
        .then(() =>
          this.$store.dispatch("jadwalKerja/drop", item.settingJadwal_id)
        )
        .then(() => {
          this.$info("Data berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    }
  }
};
</script>
